<app-booking-navbar [step]="4"></app-booking-navbar>
<div class="row mt-3" *ngIf="(basket$ | async)">
    <div class="col-12 text-right">
            <button class="btn btn-sm  btn-primary" (click)="continue()">Continue</button>
    </div>
</div>

<div *ngIf="offering">
<div class="p-2">
    <div class="row">
        <div class="col-12">
            <div class="row">
                <div class="col-12 col-md-3">
                    <div class="mt-4" *ngIf="basket">
                        <app-trb-basket [basketItem]="basket.items[itemIdx]" [basketItemIdx]="itemIdx" [latestChangeTime]="latestChangeTime" [allowDelete]="true"></app-trb-basket>
                    </div>
                </div>

                <div class="col-12 col-md-6">
                    <mat-card class="mb-3 mt-3">
                    <div class="tile mt-4">
                        <div *ngIf="offering.image" class="image-tile" [ngStyle]="{'background-image': 'url(' + offering.image.url + ')'}">

                        </div>
                        <div class="overview">
                            <p class="mat-subtitle mb-1">{{offering.name}}</p>
                            <p class="mat-subtitle mb-1">From {{(offering.price_from / 100) | currency : 'GBP'}}</p>
                            <p class="mb-1">Lasts {{offering.duration}} minutes</p>

                            <div class="alert alert-warning" *ngIf="avLoaded && !haveAvailability">
                                <p class="mb-0">Sorry, we have no appointments available for your stay dates</p>
                            </div>
                            <hr />
                            <div [innerHTML]="offering.description"></div>
                            <!-- <p class="">{{offering.description}}</p> -->
                        </div>
                    </div>

                    </mat-card>

                </div>
                <div class="col-12 col-md-3">
                    <mat-card class="mb-3 mt-3">
                    <p class="mat-title mt-4 mb-3">Select Treatment Date</p>

                    <ng-container *ngIf="haveAvailability">
                        <div class="d-flex justify-content-start">
                            <ng-container *ngFor="let d of dates; let di = index">
                                <div
                                    *ngIf="d.hasAvailability"
                                    (click)="selectDate(di)"
                                    class="mr-2 p-2 mb-2 d-container hover"
                                    [ngClass]="{'d-container-selected' : d.selected}"
                                    >
                                    {{d.date | date: 'dd MMM'}}
                                </div>

                            </ng-container>
                        </div>



                        <ng-container *ngIf="!treatmentAdded">
                            <p class="mat-subtitle mt-4 mb-3">Who will be treated?</p>

                            <div class="guest-bar d-flex justify-content-center" style="width: 100%">
                                <div style="width: 20px; text-align: center; border: none;">
                                    <a class="hover"(click)="decrement()">
                                        <i class="far fa-minus-square"></i>
                                    </a>
                                </div>
                                <div style="width: 100px; text-align: center; border: none;">
                                    <span>{{guestCount}} guest<span *ngIf="guestCount > 1">s</span></span>
                                </div>
                                <div style="width: 20px; text-align: center; border: none;">
                                    <a class="hover" (click)="increment()">
                                        <i class="far fa-plus-square"></i>
                                    </a>
                                </div>
                            </div>

                            <div class="mt-3 mb-2" *ngFor="let guest of guests; let idx = index">
                                <input class="form-control mb-1" [(ngModel)]="guest.name" placeholder="Enter guest {{idx+1}} full name" />
                            </div>

                            <button class="btn btn-primary btn-block mt-4" type="button" *ngIf="allGuestsHaveNames()" (click)="selectAppointment()">Add Treatment</button>
                        </ng-container>
                        <div *ngIf="treatmentAdded">
                            <p class="mat-subtitle text-center mt-3">Your treatment has been added</p>
                            <button type="button" class="btn btn-primary btn-block mt-4" (click)="backToTreatments()">Back to treatments</button>
                        </div>
                    </ng-container>

                    <p *ngIf="avLoaded && !haveAvailability">Sorry, we have no appointments available for your stay dates</p>

                    </mat-card>


                </div>

            </div>

        </div>
    </div>

</div>

</div>
<ng-container *ngIf="this.item && this.item.spa">
    <app-treatment-timeslot-selection *ngIf="allocatingAppointment && this.item" [basketItem]="this.item" [guests]="guests" [offering]="offering" [dateFrom]="dateFrom" (complete)="appointmentsSelected($event)"></app-treatment-timeslot-selection>
</ng-container>
